module.exports = __webpack_public_path__ + "img/icon_storage_gray.969f5fb2.svg";